import instanceService from './instance'

import {CLIENT_SERVER_URL, KB_DEAL_NUMBER_URL, KB_EXCHANGE_SERVER_URL} from '../helpers/constants'

let instance = instanceService.instance(KB_EXCHANGE_SERVER_URL)
let instanceDealNumber = instanceService.instance(KB_DEAL_NUMBER_URL)
let instanceFullName = instanceService.instance(CLIENT_SERVER_URL)

export const kbService = {
  getMessages,
  getMessage,
  markMessage,
  createMessage,
  getDealNumber,
  getClientInfo
}

function getClientInfo (data) {
  const options = {
    method: 'GET',
    url: `${data}/service`
  }
  return instanceFullName(options)
}

function getDealNumber (data) {
  const options = {
    method: 'POST',
    data: {"dealIds": data, "fields": ["dealNumber"]},
    url: `/deals`
  }
  return instanceDealNumber(options)
}

function getMessages (data) {
  const options = {
    method: 'POST',
    data: data,
    url: `/kb`
  }
  return instance(options)
}

function getMessage (messageId) {
  const options = {
    method: 'GET',
    url: `/kb/${messageId}`
  }
  return instance(options)
}

function markMessage (messageId,mark) {
  const options = {
    method: 'PUT',
    data: {
      mark: mark
    },
    url: `/kb/${messageId}`
  }
  return instance(options)
}

function createMessage (data) {
  const options = {
    method: 'POST',
    data: data,
    url: `/kb/event`
  }
  return instance(options)
}
